import { render, staticRenderFns } from "./LiveCalendar.vue?vue&type=template&id=03547117&scoped=true"
import script from "./LiveCalendar.vue?vue&type=script&lang=js"
export * from "./LiveCalendar.vue?vue&type=script&lang=js"
import style0 from "./LiveCalendar.vue?vue&type=style&index=0&id=03547117&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03547117",
  null
  
)

export default component.exports